

/*!
 * Activation de la librairie wow
 * pour les animations.
 */
new WOW().init();


/*!
 * Permet de faire un scroll automatique
 * au click sur le bouton de la home.
 */
$('.scrollTo').click( function() { // Au clic sur un élément
	var page = $(this).attr('data-href'); // Page cible
	var speed = 750; // Durée de l'animation (en ms)
	$('html, body').animate( { scrollTop: $(page).offset().top - $("header .container").height() }, speed ); // Go
	return false;
});


function youtubeEmbed() {
	$('.youtubeiframe').each(function() {
		var ifrm = document.createElement('iframe');
		if($(this).data('url')) {
			ifrm.setAttribute('src', $(this).data('url'));
			ifrm.setAttribute('frameborder', '0');
			ifrm.setAttribute('marginheight', '0');
			ifrm.setAttribute('marginwidth', '0');
			ifrm.setAttribute('scrolling', 'no');
			ifrm.setAttribute('allowfullscreen', 'allowfullscreen');
			this.appendChild(ifrm);
		}
	});
}

/* Script pour les error formulaire
 pour que la navigation ne passe pas par dessus l'erreur
 */

if(window.location.hash == "#formAnchor3") {
	var page = $(".cms_forms") // Page cible
	var speed = 750; // Durée de l'animation (en ms).navigation-container
	$('html, body').animate( { scrollTop: $(page).offset().top - $("header .container").height()-100 }, speed ); // Go
}


$('a[href^="'+window.location.pathname+'#"]').click(function(){
	var the_id = $(this).attr("href");
	var search = the_id.search("#");
	var sub = the_id.substring(search+1);
	$('html, body').animate({
		scrollTop:$("a[name^='"+sub+"']").offset().top-$(".navigation-container").height()-100
	}, 'slow');
	return false;
});


if($("body").hasClass("interior")) {
	$(window).scroll(function () {
		if($(".container-visuel").offset().top+$(".container-visuel").height()-50<$(window).scrollTop()) {
			$(".container-depart").css("display", "none");
		}else{
			$(".container-depart").css("display", "block");
		}
	})
};

if($("body").hasClass("parcours")){
	$(".parcours .mediatelechargement").addClass("img_parcours");
}

if($("body").hasClass("common")) {
	$(window).scroll(function () {
		if($(".container-visuel").offset().top+$(".container-visuel").height()-250<$(window).scrollTop()) {
			$(".container-visuel .donut-chart.center.wow.fadeInDown.animated").css("display", "none");
		}else{
			$(".container-visuel .donut-chart.center.wow.fadeInDown.animated").css("display", "block");
		}
	})
};



// if($("body").hasClass("interior")){
// 	$(".navigation-container--logo img").css("display", "block");
// }else{
// 	$(".navigation-container--logo img").css("display", "none");
// 	$(window).scroll(function (){
// 		if($(".container-visuel--logo").offset().top+$(".container-visuel--logo").height()<$(window).scrollTop()){
// 			$(".navigation-container--logo img").css("display", "block");
// 		}else{
// 			$(".navigation-container--logo img").css("display", "none");
// 		}
// 	})
// }
$('#sinscrire').attr('target', '_blank');
$('#etudiants').attr('target', '_blank');
$('#verifier-inscription').attr('target', '_blank');
$('#collaborateurs-eiffage').attr('target', '_blank');


window.gtmPushEvent = function(data) {
	//console.log("Pushing GTM Event",data);
	//check if datalayer id defined
	if(typeof dataLayer === 'undefined') {
		console.log("DataLayer not initialized",data);
		return;
	}

	dataLayer.push(data);
}

function getFirstH2ForToggler($toggle){
    let $previous = $toggle.prev();
    if($previous.is('h2')){
        return $previous;
    }

    if($previous.hasClass('toggle')){
        return getFirstH2ForToggler($previous);
    }

    return null;
}

function bindGTMPusherForToggler($toggle,$h2){
	
	let $pusher = $('.toggle-titre',$toggle);
	let chapter2 = $h2.text().trim();

	$pusher
	.attr('data-gtm-chapter2',chapter2)
	.on('click',function(){
		if($pusher.hasClass('opened')){
			onClickGTMPusher($pusher);
		}
	});
}

function initializeGTMPusherForToggler(){

	$('.toggle').each(function(){
		let $toggle = $(this);
	
		let $firstH2 = getFirstH2ForToggler($toggle);
	
		if($firstH2){
			bindGTMPusherForToggler($toggle,$firstH2);
		}
	})
}

function intializeGTMPusherForHeader(){
	let exitInscriptionId = [
		"inscription-all",
		"sinscrire",
		"verifier-inscription",
		"inscription-solo",
		"inscription-collab",
		"inscription-pompier",
		"inscription-etudiant",
	];

	let chapter1 = $('body').data('gtm-chapter1');
	let chapter2 = $('body').data('gtm-chapter2');

	let $header = $('header');
	for(var id of exitInscriptionId){
		let $element = $('#'+id,$header);
		if($element.length){
			let chapter3 = $element.text().trim();
			$element
			.addClass('gtm-event-pusher')
			.attr('data-gtm-event','click.exit')
			.attr('data-gtm-click','inscription')
			.attr('data-gtm-click-zone','Menu')
			.attr('data-gtm-chapter1',chapter1)
			.attr('data-gtm-chapter2',chapter2)
			.attr('data-gtm-chapter3',chapter3);
		}
	}
}

function getFirstH2ForElement($element){
	//return null;
	if($element.length == 0){
		return null;
	}
	if($element.is('h2')){
		return $element;
	}

	let $previous = $element.prev();
	if($previous.is('h2')){
		return $previous;
	};

	//if $previous is same element has $element take $element.parent()
	if($previous.is($element) || $previous.length == 0){
		$previous = $element.parent();
	}
	return getFirstH2ForElement($previous);
}

function initializeGTMPusherForMiscOthersLinks(){
	let $links = $('a');

	$links.each(function(){

		let event = 'click.exit';
		let $link = $(this);
		let href = $link.attr('href');
		if(!href){
			return;
		}

		let isEligible = href && href.indexOf(window.location.hostname) == -1 ? true : false;
		//if href start with / it is internal link
		if(href.startsWith('/') || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')){
			isEligible = false;
		}
		let isGTMEventPusher = $link.hasClass('gtm-event-pusher');
		if(!isGTMEventPusher && $link.hasClass('mobile-main-satellite--link')){
			isGTMEventPusher = true;
		}
		
		if(!isEligible && href.indexOf('pmedia') != -1){
			event = 'click.download';
			isEligible = true;
		}

		if(!isEligible || isGTMEventPusher){
			return;
		}

		//if href do not match current domain and link has no gtm-event-pusher class
		let click = $(this).text().trim();
		if(!click){
			click = href;
		}
		let chapter1 = $('body').data('gtm-chapter1');
		let chapter2 = $('body').data('gtm-chapter2');
		let chapter3 = '';
		let $prevH2 = getFirstH2ForElement($link);
		if($prevH2){
			chapter3 = $prevH2.text().trim();
		}
		

		$link
		.addClass('gtm-event-pusher')
		.attr('data-gtm-event',event)
		.attr('data-gtm-click',click)
		.attr('data-gtm-click-zone','')
		.attr('data-gtm-chapter1',chapter1)
		.attr('data-gtm-chapter2',chapter2)
		.attr('data-gtm-chapter3',chapter3);
	});
}

function onClickGTMPusher($element){
	let event = $element.data('gtm-event');
	let click = $element.data('gtm-click');
	let clickZone = $element.data('gtm-click-zone');
	let chapter1 = $element.data('gtm-chapter1');
	let chapter2 = $element.data('gtm-chapter2');
	let chapter3 = $element.data('gtm-chapter3');

	let data = {
		'event': event,
		'click': click,
		'click_zone': clickZone,
		'click_chapter1': chapter1 ? chapter1 : undefined,
		'click_chapter2': chapter2 ? chapter2 : undefined,
		'click_chapter3': chapter3 ? chapter3 : undefined,
	};

	gtmPushEvent(data);

}

$('body').on('click', '.gtm-event-pusher', function(e) {
	let $element = $(this);
	onClickGTMPusher($element);
});


$(document).ready(function(){
	initializeGTMPusherForToggler();
	intializeGTMPusherForHeader();
	initializeGTMPusherForMiscOthersLinks();
})